import "core-js/modules/es.array.push.js";
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-5c431738"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "launch-banner"
};
const _hoisted_2 = {
  class: "launch-banner-bg"
};
const _hoisted_3 = {
  class: "launch-banner-body"
};
const _hoisted_4 = {
  class: "launch-banner-content"
};
const _hoisted_5 = {
  class: "launch-banner-title"
};
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1));
const _hoisted_7 = {
  class: "launchpad-banner-info"
};
const _hoisted_8 = {
  class: "launchpad-banner-item"
};
const _hoisted_9 = {
  key: 0
};
const _hoisted_10 = {
  key: 1
};
const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "divider"
}, null, -1));
const _hoisted_12 = {
  class: "launchpad-banner-item"
};
const _hoisted_13 = {
  key: 0
};
const _hoisted_14 = {
  key: 1
};
const _hoisted_15 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "divider"
}, null, -1));
const _hoisted_16 = {
  class: "launchpad-banner-item"
};
const _hoisted_17 = {
  key: 0
};
const _hoisted_18 = {
  key: 1
};
const _hoisted_19 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "divider"
}, null, -1));
const _hoisted_20 = {
  class: "launchpad-banner-item"
};
const _hoisted_21 = {
  key: 0
};
const _hoisted_22 = {
  key: 1
};
const _hoisted_23 = {
  class: "actions"
};
const _hoisted_24 = {
  class: "launch-banner-icon-container"
};
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRouter } from 'vue-router';
import { useStore } from 'vuex';
import { toLogin, noBybitToRegister } from '@/utils/jumpLink';
import { toFormat } from '@/utils/number';
import { saPushEvent } from '@/utils/sensors';
import TextLink from '@/components/text-link';
import ImageCanvas from '@/components/ImageCanvas';
import { useInvitation } from '../hooks/useInvitation';
export default {
  __name: 'HomeBannerNew',
  props: {
    overviewData: {
      type: Object,
      default: null
    }
  },
  setup(__props) {
    const {
      t,
      locale
    } = useI18n();
    const store = useStore();
    const invitation = useInvitation();
    const userstate = computed(() => store.state.user.userstate);
    const router = useRouter();
    const env = process.env.NODE_ENV;
    const reportAction = btnName => {
      saPushEvent('SpotLpadHomePageHeadingClick', {
        page_name: 'LpadHomePage',
        plate_area: 'Heading',
        button_name: btnName
      });
    };
    const goUserCenter = () => {
      reportAction('UserCenter');
      if (userstate.value !== 1) {
        if (noBybitToRegister('spotx_launchpad_ongoing')) {
          return;
        }
        toLogin(window.location.href);
      } else {
        router.push(`/${locale.value}/trade/spot/launchpad-order`);
      }
    };
    const goReferralCenter = () => {
      if (userstate.value !== 1) {
        if (noBybitToRegister('spotx_launchpad_ongoing')) {
          return;
        }
        toLogin(window.location.href);
      } else {
        window.open(`/${locale.value}/trade/spot/spotx/referral-records-rules?source=1`);
      }
    };
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_unref(ImageCanvas), {
        src: _unref(env) === 'development' ? 'https://s1.bycsi.com/bybit/deadpool/image-4ba3580e831f420c8d9e59420649bb37.png' : '/bycsi-root/bybit/deadpool/image-4ba3580e831f420c8d9e59420649bb37.png',
        width: "auto",
        height: "290"
      }, null, 8, ["src"])]), _createElementVNode("div", _hoisted_3, [_createElementVNode("section", _hoisted_4, [_createElementVNode("span", _hoisted_5, [_createElementVNode("span", null, _toDisplayString(_unref(t)('lpn_launchpad')), 1), _hoisted_6, _createElementVNode("span", null, _toDisplayString(_unref(t)('lpn_banner_title')) + " " + _toDisplayString(_unref(t)('lpn_banner_subtitle')), 1)]), _createElementVNode("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, [_createElementVNode("div", null, _toDisplayString(_unref(t)('lpn_total_funds_raised')), 1), __props.overviewData?.totalAmount ? (_openBlock(), _createElementBlock("div", _hoisted_9, " $" + _toDisplayString(_unref(toFormat)(__props.overviewData?.totalAmount, 0)), 1)) : (_openBlock(), _createElementBlock("div", _hoisted_10, " -- "))]), _hoisted_11, _createElementVNode("div", _hoisted_12, [_createElementVNode("div", null, _toDisplayString(_unref(t)('lpn_avg_growth')), 1), __props.overviewData?.growth ? (_openBlock(), _createElementBlock("div", _hoisted_13, _toDisplayString(_unref(toFormat)(__props.overviewData?.growth, 0)) + "% ", 1)) : (_openBlock(), _createElementBlock("div", _hoisted_14, " -- "))]), _hoisted_15, _createElementVNode("div", _hoisted_16, [_createElementVNode("div", null, _toDisplayString(_unref(t)('lpn_participants')), 1), __props.overviewData?.totalUser ? (_openBlock(), _createElementBlock("div", _hoisted_17, _toDisplayString(_unref(toFormat)(__props.overviewData?.totalUser, 0)), 1)) : (_openBlock(), _createElementBlock("div", _hoisted_18, " -- "))]), _hoisted_19, _createElementVNode("div", _hoisted_20, [_createElementVNode("div", null, _toDisplayString(_unref(t)('lpn_issue_items_total')), 1), __props.overviewData?.totalProjects ? (_openBlock(), _createElementBlock("div", _hoisted_21, _toDisplayString(_unref(toFormat)(__props.overviewData?.totalProjects, 0)), 1)) : (_openBlock(), _createElementBlock("div", _hoisted_22, " -- "))])]), _createElementVNode("div", _hoisted_23, [_createVNode(_unref(TextLink), {
        text: _unref(t)('tokenSaleRecords'),
        onClick: goUserCenter
      }, null, 8, ["text"]), _createVNode(_unref(TextLink), {
        text: _unref(t)('referralHistRules'),
        onClick: goReferralCenter
      }, null, 8, ["text"])])]), _createElementVNode("div", _hoisted_24, [_createVNode(_unref(ImageCanvas), {
        src: _unref(env) === 'development' ? 'https://s1.bycsi.com/bybit/deadpool/image-c3ef409db1af42458febbfb491ec6859.png' : '/bycsi-root/bybit/deadpool/image-c3ef409db1af42458febbfb491ec6859.png',
        width: "310",
        height: "276"
      }, null, 8, ["src"])])])]);
    };
  }
};